import moment from "moment"

export default function (props) {
    const textTime = props ? moment(props).format('HH:mm DD/MM/YYYY') : '-'

    return textTime
}